// TODO: Fix this part after API ready
// import {
//   FETCH_TITLE_BY_ROLE_SUCCEEDED,
// } from '../constants/ActionTypes';

// export function fetchTitleByRoleSucceeded(data) {
//   return {
//     type: FETCH_TITLE_BY_ROLE_SUCCEEDED,
//     data,
//   };
// }

import { createActions } from 'redux-actions';

import ActionFactory from './ActionFactory';
import {
  METADATA,
  GET_METADATA,
  CREATE_METADATA,
  UPDATE_METADATA,
  DELETE_METADATA,
} from '../constants/ActionTypes';
import MetadataAPIConnectors from '../api/MetadataAPIConnectors';

const plainActions = createActions(
  ...Object.values(ActionFactory(GET_METADATA)),
  ...Object.values(ActionFactory(CREATE_METADATA)),
  ...Object.values(ActionFactory(UPDATE_METADATA)),
  ...Object.values(ActionFactory(DELETE_METADATA)),
  { prefix: METADATA },
);

const thunkActions = {
  getMetadata: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getMetadataRequest());
        const metadatas = await MetadataAPIConnectors.getMetadata();
        const metadataTypes = await MetadataAPIConnectors.getMetadataType();
        dispatch(plainActions.getMetadataSuccess({ metadatas, metadataTypes }));
        return true;
      } catch (err) {
        dispatch(plainActions.getMetadataFailure(err));
        return err;
      }
    }
  ),
  createMetadata: data => (
    async (dispatch) => {
      try {
        dispatch(plainActions.createMetadataRequest());
        const result = await MetadataAPIConnectors.createMetadata(data);
        dispatch(plainActions.createMetadataSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.createMetadataFailure(err));
        return err;
      }
    }
  ),
  updateMetadata: data => (
    async (dispatch) => {
      try {
        dispatch(plainActions.updateMetadataRequest());
        const result = await MetadataAPIConnectors.updateMetadata(data);
        dispatch(plainActions.updateMetadataSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.updateMetadataFailure(err));
        return err;
      }
    }
  ),
  deleteMetadata: data => (
    async (dispatch) => {
      try {
        dispatch(plainActions.deleteMetadataRequest());
        const result = await MetadataAPIConnectors.deleteMetadata(data);
        dispatch(plainActions.deleteMetadataSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.deleteMetadataFailure(err));
      }
      return false;
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/MetadataActionCreators.js